import React from 'react';

const SumoRobotTeknologi: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <h2 className="text-lg font-semibold mb-3">
                🤖 Robotik dan Perkembangannya di Era Teknologi
            </h2>

            <p className="mb-2">
                Di era perkembangan teknologi yang semakin pesat, dunia robotik mengalami kemajuan signifikan seiring hadirnya sistem otomatis dan kecerdasan buatan. Kondisi ini mendorong meningkatnya minat generasi muda terhadap pembelajaran robotika, baik melalui kegiatan ekskul robot di sekolah maupun berbagai program edukasi berbasis teknologi.
            </p>

            <p className="mb-4">
                Dalam ekosistem pembelajaran tersebut, sejumlah platform dan komunitas edukasi robotik turut berperan aktif, seperti <a href="https://indobot.co.id/" className="text-blue-600 underline font-semibold hover:text-blue-800" target='_blank'>Indobot Academy</a>, <a href="https://www.robotics.co.id/" className="text-blue-600 underline font-semibold hover:text-blue-800" target='_blank'>Robotics Education Centre</a>, serta berbagai komunitas STEM yang fokus memperkenalkan robotika sebagai bagian dari penguatan talenta digital sejak dini.
            </p>

            <h3 className="text-md font-semibold mb-2">
                🏆 Prestasi Robotik Pelajar Indonesia
            </h3>

            <p className="mb-4">
                Perkembangan ini tercermin dari berbagai prestasi pelajar dan mahasiswa Indonesia di bidang robotik. Tim robotika Institut Teknologi Sepuluh Nopember (ITS) berhasil meraih <a href="https://intimedia.id/read/its-students-win-international-robot-competition-awards-in-mongolia" className="text-blue-600 underline font-semibold hover:text-blue-800" target='_blank'>Best Design Award dan Kajima Award</a> pada ajang internasional ABU Robocon 2025 di Mongolia.
            </p>

            <p className="mb-4">
                Selain itu, Tim Robotik MTsN 7 Jakarta berhasil meraih Juara 1 kategori Sumo Robot pada <a href="https://dki.kemenag.go.id/berita/tim-robotik-mtsn-7-jakarta-raih-juara-1-di-fira-indonesia-open-2025-ZcgI0" className="text-blue-600 underline font-semibold hover:text-blue-800" target='_blank'>FIRA Indonesia Open 2025</a>, kompetisi robotik internasional yang diikuti peserta dari lebih dari 20 negara.
            </p>

            <h3 className="text-md font-semibold mb-2">
                ⚙️ Lomba Sumo Robot Game
            </h3>

            <p className="mb-4">
                Lomba Sumo Robot Game menjadi salah satu kompetisi yang relevan dengan kebutuhan zaman karena menantang peserta untuk merancang robot yang mampu mengambil keputusan cepat dan tepat. Kompetisi ini tidak hanya menampilkan adu kekuatan mekanik, tetapi juga kecerdasan strategi yang tertanam dalam sistem pemrograman.
            </p>

            <ul className="list-disc list-inside space-y-2 mb-4">
                <li>Perancangan desain rangka dan struktur robot</li>
                <li>Pemilihan motor dan sistem penggerak</li>
                <li>Penggunaan sensor untuk membaca kondisi arena</li>
                <li>Logika kontrol yang stabil dan responsif</li>
            </ul>

            <h3 className="text-md font-semibold mb-2">
                🚀 Dukungan Pendidikan dan Talenta Muda
            </h3>

            <p className="mb-4">
                Pendekatan pembelajaran ini sejalan dengan meningkatnya minat terhadap ekskul robot yang juga didorong dalam pengembangan talenta muda. Dukungan terhadap penguatan keterampilan robotik dan STEM juga diberikan oleh berbagai platform edukasi, salah satunya AEDU (Accelist Edukasi).
            </p>

            <p className="mb-4">
                Informasi lengkap mengenai program AEDU dapat diakses melalui{' '}
                <a href="https://edukasi.accelist.com/" className="text-blue-600 underline font-semibold" target='_blank'>
                    website AEDU
                </a>.
            </p>

            <p className="text-gray-700">
                Melalui ajang yang diselenggarakan oleh <strong>IIT</strong>, Lomba Sumo Robot Game hadir sebagai wadah pembinaan yang terstruktur dan berkelanjutan bagi generasi muda. Kompetisi ini tidak hanya mengasah kemampuan teknis, tetapi juga melatih berpikir kritis, kreatif, dan adaptif terhadap perkembangan teknologi dan kecerdasan buatan.
            </p>

            <p className="mt-4 font-semibold">
                👉{' '}
                Cek informasi Lomba <a href="/iit-program?program=SumoRobot" className="text-blue-600 underline font-semibold hover:text-blue-800" target='_blank'>Sumo Robot Game</a> lebih lanjut
            </p>
        </div>
    )
}

export default SumoRobotTeknologi;
